import type { DeviceViewElementType } from 'components/DeviceView/deviceViewTypes';
import type { GraphState } from 'components/Graph/GraphState';
import { selectPathLookupApplied } from 'components/Graph/model/selectors/graphMetadata/selectPathLookupApplied';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';
import { selectPathLookupPathInspectorSelectedNodeSns } from './selectPathLookupPathInspectorSelectedNodeSns';

export const selectCanDestroyPathLookupPathInspectorNode: (
  s: GraphState,
) => (deviceViewElement: DeviceViewElementType) => boolean =
  createScopedSelector(() =>
    createSelector(
      selectPathLookupApplied,
      (s) => selectPathLookupPathInspectorSelectedNodeSns(s).length > 0,
      (isAppliedPathLookup, selectedSomePathInspectorNodes) =>
        (deviceViewElement) =>
          isAppliedPathLookup &&
          deviceViewElement === 'node' &&
          selectedSomePathInspectorNodes,
    ),
  );
